<template>
  <div class="row">
    <div class="col col-md-12">
      <div
        v-if="mensagem !== '' && view !== 'modal'"
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>{{ mensagem }}</strong>
      </div>
      <Dialog
        :id="'dialogBackupListFiltro'"
        ref="dialogBackupListFiltro"
        :hide-header="true"
        :modal="view == 'modal'"
        tamanho="xl"
      >
        <div>
          <div class="d-flex justify-content-end">
            <div
              class="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span class="svg-icon svg-icon-1" @click="$emit('dialog-off')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect
                    opacity="0.5"
                    x="6"
                    y="17.3137"
                    width="16"
                    height="2"
                    rx="1"
                    transform="rotate(-45 6 17.3137)"
                    fill="currentColor"
                  ></rect>
                  <rect
                    x="7.41422"
                    y="6"
                    width="16"
                    height="2"
                    rx="1"
                    transform="rotate(45 7.41422 6)"
                    fill="currentColor"
                  ></rect>
                </svg>
              </span>
            </div>
          </div>
          <div class="fv-row mb-7 text-center">
            <h2 class="fw-bolder">Filtrar</h2>
          </div>
        </div>

        <div>
          <div class="fv-row mb-3">
            <label class="fs-6 fw-bold mb-2">Backup</label>
            <Combo
              v-model="item.filtroBackup"
              :itens="backups"
              autofocus="true"
              :classSelect2="false"
            />
          </div>

          <div class="row mb-5">
            <div class="col-6">
              <label class="fs-6 fw-bold mb-2">Instância</label>

              <input
                v-model="item.filtroInstancia"
                class="form-control form-control-solid"
                type="text"
                autofocus="true"
                autocomplete="off"
                placeholder=""
              />
            </div>
            <div class="col-6" v-if="storeAuth.sessao.usuario.tipoUsuario == 'adminNuvem'">
              <label class="fs-6 fw-bold mb-2">Usuário</label>
              <Combo
                v-model="item.filtroUsuario"
                :itens="usuarios"
                autofocus="true"
                :classSelect2="false"
              />
            </div>
          </div>

          <div class="row mb-5">
            <label class="fs-6 fw-bold mb-2">Data</label>
            <div class="col-6 fv-row">
              <label class="fs-6 fw-bold mb-2 text-muted">De</label>
              <div class="d-flex">
                <input
                  v-model="item.filtroDataInicio"
                  class="form-control form-control-solid me-2"
                  type="date"
                  autofocus="true"
                  autocomplete="off"
                />
                <input
                  v-model="item.filtroHoraInicio"
                  class="form-control form-control-solid"
                  type="time"
                  autofocus="true"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="col-6 fv-row">
              <label class="fs-6 fw-bold mb-2 text-muted">Até</label>
              <div class="d-flex">
                <input
                  v-model="item.filtroDataFim"
                  class="form-control form-control-solid me-2"
                  type="date"
                  autofocus="true"
                  autocomplete="off"
                />
                <input
                  v-model="item.filtroHoraFim"
                  class="form-control form-control-solid"
                  type="time"
                  autofocus="true"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>

          <div class="row mb-5">
            <div class="col-6">
              <label class="fs-6 fw-bold mb-2">Status</label>
              <Combo
                v-model="item.filtroStatus"
                :itens="[
                  { id: '', nome: 'Todos' },
                  { id: 'sucesso', nome: 'Sucesso' },
                  { id: 'erro', nome: 'Erro' }
                ]"
                autofocus="true"
                :classSelect2="false"
              />
            </div>
          </div>
        </div>

        <template #rodape>
          <div class="row">
            <div
              class="col-md-12 col-sm-12 d-flex justify-content-center"
              style="align-items: center; padding: 0.75rem"
            >
              <button
                type="button"
                class="btn btn-secondary me-1"
                @click="limpar()"
              >
                Limpar
              </button>
              <button type="button" class="btn btn-warning" @click="fechar()">
                Aplicar
              </button>
            </div>
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/plugins/api.js";
import { useAuthStore } from "@/stores/auth.js";

import Dialog from "../components/ComponentDialog.vue";
import Combo from "../components/ComponentCombo.vue";

export default {
  components: { Combo, Dialog },
  props: {
    view: { type: String, default: "modal" }
  },

  computed: {},

  setup() {
    const storeAuth = useAuthStore();

    return { storeAuth };
  },

  data() {
    return {
      item: {
        filtroBackup: "",
        filtroInstancia: "",
        filtroStatus: "",
        filtroUsuario: "",
        filtroDataInicio: "",
        filtroHoraInicio: "",
        filtroDataFim: "",
        filtroHoraFim: ""
      },
      usuarios: [],
      backups: []
    };
  },

  mounted() {
    //* Carrega os backups
    this.carregarBackups();

    //* Carrega os usuarios
    this.carregarUsuarios();
  },

  methods: {
    abrir() {
      this.$emit("dialog-on");
      this.$refs.dialogBackupListFiltro.abrir();
    },
    fechar() {
      this.$refs.dialogBackupListFiltro.fechar();
      this.$emit("dialog-off");
    },

    async carregarUsuarios() {

      //* Define os usuarios
      this.usuarios = [{ id: "", nome: "Todos" }];

      //* Verifica o tipo de usuario
      if(this.storeAuth.sessao.usuario.tipoUsuario !== "adminNuvem") {
        this.usuarios = {};
        return;
      } 
      
      //* Define o token
      const token =
        this.$props.instancia !== "" &&
        this.storeAuth.token[this.$props.instancia] !== ""
          ? this.storeAuth.token[this.$props.instancia]
          : localStorage.getItem("ckd");

      //* Carrega os usuarios
      const response = await api.get(
        window._env_.VUE_APP_URL_API + "/admin/usuario",
        token
      );
      api.valid(response.data, this.$router);

      //* Verifica se carregou
      if (response.data.erro == false) {
        //* Percorre os usuarios encontrados
        for (
          let indiceUsuario = 0;
          indiceUsuario < response.data.itens.length;
          indiceUsuario++
        ) {
          //* Insere na lista
          let itemUsuario = response.data.itens[indiceUsuario];
          this.usuarios.push({ id: itemUsuario._id, nome: itemUsuario.nome });
        }
      }
    },
    async carregarBackups() {
      //* Carrega os backups
      const response = await api.get(this.storeAuth.apiNuvem() + "/backup");

      api.valid(response.data, this.$router);

      //* Define os backups
      this.backups = [{ id: "", nome: "Todos" }];

      //* Verifica se carregou
      if (response.data.erro == false) {
        //* Percorre os backups encontrados
        for (
          let indiceItem = 0;
          indiceItem < response.data.itens.length;
          indiceItem++
        ) {
          //* Insere na lista
          let item = response.data.itens[indiceItem];
          this.backups.push({ id: item._id, nome: item.nome });
        }
      }
    },
    limpar() {
      //* Limpar os filtros
      this.item.filtroBackup = "";
      this.item.filtroInstancia = "";
      this.item.filtroStatus = "";
      this.item.filtroUsuario = "";
      this.item.filtroDataInicio = "";
      this.item.filtroHoraInicio = "";
      this.item.filtroDataFim = "";
      this.item.filtroHoraFim = "";
    }
  }
};
</script>

<style></style>
